import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FlightsComponent } from './flights.component';
import { ResultComponent } from './result/index';
import { BookingComponent, ConfirmPassengerComponent, BookingConfirmComponent } from './booking/index';
import { GuestDetailsComponent } from './booking/guest-details/guest-details.component';
import { PaymentDetailsComponent } from './booking/payment-details/payment-details.component';
import { VoucherComponent } from './booking/voucher/voucher.component';
import { MobileVoucherComponent } from './booking/mobile-voucher/mobile-voucher.component';
import { PaymentStatusComponent } from './booking/payment-details/payment-status/payment-status.component';

const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: '',
                component: FlightsComponent,
                data: { extraParameters: '' }
            },
            {
                path: 'flight-result',
                component: ResultComponent,
                data: { extraParameter: '' }
            },
            {
                path: 'flight/booking',
                component: BookingComponent,
                data: { extraParameter: '' }
            },
            {
                path: 'flight/confirm-passenger',
                component: ConfirmPassengerComponent,
                data: { extraParameter: '' }
            },
            {
                path: 'flight/booking-confirm',
                component: BookingConfirmComponent,
                data: { extraParameter: '' }
            },
            {
                path: 'flight/guest-details',
                component: GuestDetailsComponent,
                data: { extraParameter: '' }
            },
            {
                path: 'flight/payment-details',
                component: PaymentDetailsComponent,
                data: { extraParameter: '' }
            },
            {
                path: 'flight/flight-voucher',
                component: VoucherComponent,
                data: { extraParameter: '' }
            },
            {
                path: 'flight/mobile-flight-voucher',
                component: MobileVoucherComponent,
                data: { extraParameter: '' }
            },
            {
                path: 'flight/payment-status',
                component: PaymentStatusComponent,
                data: { extraParameter: '' }
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FlightsRoutingModule { }
